var Base = require('_js/base'),
  $ = require('jquery');

function FilterLinks() {
  this.init();
}

FilterLinks.prototype = new Base();

FilterLinks.prototype.init = function() {
  //Accordion on mobile
  var $accordion = $('.filter-links-content .btn-accordion');
  $accordion.on('click', function(e) {
    e.preventDefault();
    $(this)
      .parent()
      .toggleClass('is-active');
  });
};

module.exports = FilterLinks;
